import $ from 'jquery';
import debounce from 'lodash-es/debounce';

class ReadMoreArchive {
	constructor() {
		this.window = $( window );
		this.button = $( '[data-read-more]' );
		this.buttonParent = this.button.parent();
		this.text = this.button.siblings( '.term-description' );
		this.textMaxHeight = this.button.data( 'read-more' );

		this.events();
		this.documentReady();
		this.window.on( 'resize', debounce( () => this.documentReady(), 100 ) );
	}

	events() {
		this.buttonParent.on( 'click',
			'[data-read-more]',
			() => {
				this.text.hasClass( 'hide-text' ) ? this.showText() : this.hideText(); // eslint-disable-line no-unused-expressions
			}
		);
	}

	documentReady() {
		// Hide button and show text if button is visable.
		if ( this.button.is( ':visible' ) ) {
			this.hideButton();
		}

		if ( 992 > this.window.innerWidth() ) {
			if ( this.textMaxHeight <= this.text.outerHeight() ) {
				this.showButton();
			}
		} else {
			this.hideButton();
		}
	}

	showButton() {
		this.text.addClass( 'hide-text' );
		this.text.css( 'max-height', this.textMaxHeight );
		this.button.show();
	}

	hideButton() {
		this.text.removeClass( 'hide-text' );
		this.text.removeAttr( 'style' );
		this.button.hide();
	}

	showText() {
		this.text.removeClass( 'hide-text' );
		this.text.css( 'max-height', '999px' );
		this.button.html( mainScriptTranslations.showLess ); // eslint-disable-line no-undef
	}

	hideText() {
		this.text.addClass( 'hide-text' );
		this.text.css( 'max-height', this.textMaxHeight );
		this.button.html( mainScriptTranslations.showMore ); // eslint-disable-line no-undef
	}
}

export default ReadMoreArchive;
